import { getUserConfiguration } from 'owa-session-store';
import getDomainDetails from './getDomainDetails';
import { isFeatureEnabled } from 'owa-feature-flags';
import store from '../store/store';
import { fetchLegacyUserDomainData } from '../actions/fetchLegacyUserDomainData';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import isDeprecateLegacyPremiumEnabled from './isDeprecateLegacyPremiumEnabled';
import { HMPlusBit } from 'owa-domain-connect';

function getPremiumUserData() {
    if (isConsumer() && isFeatureEnabled('auth-PremiumTransferDomainTab')) {
        fetchLegacyUserDomainData();
        getDomainDetails();
    }
    isPremiumApiCallInitialized = true;
}

let isPremiumApiCallInitialized: boolean = false;

export function isTransferDomainOptionHidden(): boolean {
    if (!isPremiumApiCallInitialized) {
        getPremiumUserData();
    }
    // legacy byod
    const isHidden = store.legacyPremiumTenant.DomainPurchaseType != 3;

    var isLegacyPremiumTenantEmpty = store.legacyPremiumTenant.TenantName == null;
    return (
        isHidden ||
        ishiddenDomainPurchaseType() ||
        !getUserConfiguration().SessionSettings.IsPremiumConsumerMailbox ||
        !isFeatureEnabled('auth-PremiumTransferDomainTab') ||
        isLegacyPremiumTenantEmpty ||
        validateHMPlusBit()
    );
}

function validateHMPlusBit(): boolean {
    return isDeprecateLegacyPremiumEnabled()
        ? false
        : (getUserConfiguration().SessionSettings.PremiumAccountOffers & HMPlusBit) != HMPlusBit;
}

function ishiddenDomainPurchaseType(): boolean {
    return isDeprecateLegacyPremiumEnabled()
        ? store.legacyPremiumTenant.DomainPurchaseType == 0 ||
              store.legacyPremiumTenant.DomainPurchaseType == 1
        : false;
}
